import ConfigForm, {
  ConfigInput,
  FormOption,
} from "components/Layout/ConfigForm";
import React from "react";

export enum LogbookTimeType {
  SIGN_IN_OUT = "Sign-in/Sign-out",
  SINGLE_TIME = "Single Time",
  NONE = "None",
}

export interface BasicLogbookConfigProps {
  name: string;
  timeType: LogbookTimeType;
  handleLogbookNameChange: (name: string) => void;
  handleLogbookTimeTypeChange: (timeType: LogbookTimeType) => void;
}

export default function BasicLogbookConfig(props: BasicLogbookConfigProps) {
  const handleLogbookNameChange = (event: any) => {
    props.handleLogbookNameChange(event.target.value);
  };

  const handleLogbookTimeTypeChange = (event: any) => {
    props.handleLogbookTimeTypeChange(event.target.value);
  };

  const logbookTimeTypes: FormOption[] = [
    {
      value: LogbookTimeType.SIGN_IN_OUT,
      label: LogbookTimeType.SIGN_IN_OUT,
    },
    {
      value: LogbookTimeType.SINGLE_TIME,
      label: LogbookTimeType.SINGLE_TIME,
    },
    {
      value: LogbookTimeType.NONE,
      label: LogbookTimeType.NONE,
    },
  ];

  const inputs: ConfigInput[] = [
    {
      title: "Logbook Name",
      required: true,
      type: "text",
      onChange: handleLogbookNameChange,
      xs: 12,
      sm: 6,
      id: "logbookName",
      value: props.name,
      placeholder: "Required",
    },
    {
      title: "Select Logbook Time Type",
      type: "select",
      onChange: handleLogbookTimeTypeChange,
      xs: 12,
      sm: 6,
      id: "logbookTimeType",
      placeholder: "Please select a time format",
      options: logbookTimeTypes,
      value: props.timeType,
    },
  ];

  return <ConfigForm inputs={inputs}></ConfigForm>;
}
